import * as theme from '@zero/design-tokens/build/js/variables';
import styled from 'styled-components';
import { Button } from 'uol-host-react-ui'
import { device } from 'uol-host-react-ui/dist/atoms/Pagination/devices'

interface ButtonProps {
    width: string;
}

export const ModalHeader = styled.div`
    margin-bottom: 24px;
    border-bottom: 1px solid var(--ancestral-water);
`

export const Title = styled.p`
    font-family: ${theme.ZrFontFamilyDigitalBold};
    font-size: 16px;
    font-weight: bold;
`;

export const TitleColor = styled.span`
    color: #CC001B;
`;

export const ModalText = styled.p`
    font-size: 14px;
    color: ${theme.ZrColorNeutralMedium01};
    font-family: ${theme.ZrFontFamilyDigitalRegular};
    margin: 0;
`;

export const ModalButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 24px;

    
    @media ${device.tablet} {
        flex-direction: column;
    }
`;

export const ButtonCustom = styled(Button) <ButtonProps>`
    width: ${p => p.width};


    @media ${device.tablet} {
        width: 100%;
        max-width: 100%;
        font-size: ${theme.ZrFontSizeXxs};
        margin-top: ${theme.ZrSpacingVerticalXxs};
     }
    `;